import React, { useCallback } from 'react';
import articlesData from '../data/javascripts/articlesData';
import { useNavigate } from 'react-router-dom';
import ArticleCard from '../widgets/ArticleCard'; // The specific card component
import HorizontalCardDeck from '../widgets/HorizontalCardDeck';
import ActionButton from '../widgets/ActionButton';

const Articles = () => {
    const navigate = useNavigate();
    
    const renderArticleItem = useCallback((article) => {
        return (
            <ArticleCard
                article={article}
            />
        );
    }, []);

    return (
        <section id="articles" className="bg-bg-light dark:bg-bg-dark">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-8">
                    <h2 className="section-heading text-primary dark:text-secondary">
                        Recent Articles
                    </h2>
                </div>

                <HorizontalCardDeck 
                    items={articlesData} // The data array
                    renderItem={renderArticleItem} // The function that returns the ArticleCard JSX
                />

                <div className="text-center mt-12">
                    <ActionButton 
                        text="View All Articles" 
                        onClick={() => navigate('/articles')} 
                        className="btn-md"
                    />
                </div>
            </div>
        </section>
    );
};

export default React.memo(Articles);